"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useLocale, useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
  section4de,
  section4en,
} from "../../../../../../public/images/blogs/haveAFloorPlanCreated";

export default function BlogContent() {
  const t = useTranslations("blogs.haveAFloorPlanCreated");
  const locale = useLocale();

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br />,
            link: (chunks) => (
              <BlogLink href="/verkaufsoptimierte-grundrisse">
                {chunks}
              </BlogLink>
            ),
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br />,
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br />,
            link: (chunks) => (
              <BlogLink href="/blog/grundriss-erstellen">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/cad-system">{chunks}</BlogLink>
            ),
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section4.title")}
          text={t.rich("sections.section4.text", {
            br: () => <br />,
            link: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
          })}
          src={locale === "de" ? section4de : section4en}
          alt={t("sections.section4.imageAlt")}
          disclaimer="default"
        />
      </div>
    </>
  );
}
